import { render, staticRenderFns } from "./ModalLicense.vue?vue&type=template&id=2aa1bb58&scoped=true&"
import script from "./ModalLicense.vue?vue&type=script&lang=js&"
export * from "./ModalLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa1bb58",
  null
  
)

export default component.exports